import React, { useEffect, useMemo, useState } from 'react'
import { Item } from '../../../common/snippets'
import { ReportHeading } from '../common/ReportHeading'
import { Box, Button } from '@mui/material'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import moment from 'moment'
import Datepicker from '../../../common/datePicker'
import { SplitButton } from '../../../common/SplitButton'
import DropDownOA from '../../../common/dropDownOA'
import { connect } from 'react-redux'
import { getOwnChildBranches } from '../../../../store/reports/reports_action'
import { getCityList } from '../../../../store/common/common_action'
import { isEmpty } from '../../../common/helper'
import { useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { GetRequest } from '../../../common/api'
import { urls, xlCol, xlColq } from '../../../common/constants'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../../helpers/useTokens'
import { downloadPDF } from '../analysisReport/pdfAutotable'
import { getDecryptedReportParams } from '../../../common/loginDecode'
const TopayStatenentReport = (props) => {
  const { data: { common, reports }, getOwnChildBranches, getCityList } = props
  const { loginData: commonLoginData, cityList,companySettings } = common
  const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
  const { ownChildBranches } = reports
  const reportName = 'To-Pay Statement'
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [selBranch, setSelBranch] = useState([])
  const [sourceCityData, setSourceCityData] = useState([])
  const [sourceCity, setSourceCity] = useState([])
  const [sourceBranchData, setSourceBranchData] = useState(ownChildBranches)
  const [sourceBranch, setSourceBranch] = useState([])
  const setAlert = useSetAtom(alertAtom)
  const setLoader = useSetAtom(globalLoaderAtom)
  const [urlSearchParams] = useSearchParams()
  const searchParams = getDecryptedReportParams(urlSearchParams)
  const tokenLoginData = useToken()?.loginData
  const hasUrlLoginData = searchParams.has('C') || searchParams.has('B') || searchParams.has('U')
  const isFromUrl = !tokenLoginData && hasUrlLoginData
  const loginData = useMemo(() => {
    if (!isFromUrl) {
      return tokenLoginData || commonLoginData
    }

    return {
      intCompanyID: searchParams.get('C') || 0,
      intBranchCityID: Number(searchParams.get('CT')) || 0,
      strCityName: searchParams.get('CTN') || '',
      intUserID: searchParams.get('U') || 0,
      intBranchID: Number(searchParams.get('B')) || 0,
      strCompanyName: searchParams.get('CN') || '',
      strUserName: searchParams.get('UN') || '',
      strBranchName: searchParams.get('BN') || '',
      IsBranchAdmin: searchParams.get('IBA') || 0,
      IsMTPLAdmin: searchParams.get('IMPTLA') || 0,
      IsAdmin: searchParams.get('IA') || 0,
    }
  }, [commonLoginData, isFromUrl, searchParams, tokenLoginData])
   const filterHeaderData = [
          { header: 'From Data', exportHead: 'From Data', field: 'fromDate', xlCol: xlCol, minWidth: "80px", align: "left" },
          { header: 'To Date', exportHead: 'To Date', field: 'toDate', xlCol: xlCol, minWidth: "100px", align: "left" },
          { header: 'City Name', exportHead: 'City Name', field: 'sourceBranch', xlCol: xlCol, minWidth: "80px", align: "left" },
          { header: 'Branch Name', exportHead: 'Branch Name', field: 'sourceCity', xlCol: xlCol, minWidth: "100px", align: "left" },
        ]
        let columnHeader = [
                { header: 'Challan\nNumber', exportHead: 'Challan\nNo.', field: 'CHALLANNO', xlCol: xlCol, isSortIcon: true, weight: 30, showfilter: true },
                { header: 'Receiver\nName', exportHead: 'Receiver\nName', field: 'RECEIVERNAME', xlCol: xlCol, isSortIcon: true, weight: 30, showfilter: true },
                { header: 'From\nStation', exportHead: 'From\nStation', field: 'FROMSTATION', xlCol: xlCol, isSortIcon: true, weight: 30, showfilter: true },
                { header: 'Booking\nDate', exportHead: 'Booking\nDate', field: 'INCOMINGDATE', xlCol: xlCol, isSortIcon: true, weight: 30, showfilter: true },
                { header: 'WayBill\nNumber', exportHead: 'WayBill\nNo.', field: 'WAYBILLNO', xlCol: xlCol, isSortIcon: true, weight: 30, showfilter: true },
                { header: 'Number\nof Parcel', exportHead: 'NOP', field: 'NOPS', xlCol: xlColq, isSortIcon: true, weight: 30, showfilter: true },
                { header: 'Opening\nBalance', exportHead: 'Opening\nBalance', field: 'OPENINGBAL', xlCol: xlColq, isSortIcon: true, weight: 30, showfilter: true },
                { header: 'ToPay\nAmount', exportHead: 'ToPay\nAMT', field: 'TODAYAMT', xlCol: xlColq, isSortIcon: true, weight: 30, showfilter: true },
                { header: 'Receive\nAmount', exportHead: 'Receive\nAMT', field: 'RECEIVEAMT', xlCol: xlColq, isSortIcon: true, weight: 30, showfilter: true },
                { header: 'Receipt\nNumber', exportHead: 'Receipt\nNo.', field: 'RECEIPTNO', xlCol: xlCol, isSortIcon: true, weight: 30, showfilter: true },
                { header: 'Due\nAmount', exportHead: 'Due\nAMT', field: 'DUEAMT', xlCol: xlColq, isSortIcon: true, weight: 30, showfilter: true },
                { header: 'Delivery\nDate', exportHead: 'Delivery\nDate', field: 'DeliveryDate', xlCol: xlCol, isSortIcon: true, weight: 30, showfilter: true },
            ]
            let columnHeaderUpdated = columnHeader.map((col) => {
                if (UseToPayAsCOD === 1) {
                    if (col.field === 'TODAYAMT') {
                        return {
                            ...col,
                            headerName: 'COD\nAMT',
                            exportHead: 'COD\nAMT',
                        };
                    }
                }
                return col;
            });
  useEffect(() => {
    if (cityList.length > 0) {
      const cityListWithAll = [{ CityID: 0, CityName: 'All' }, ...cityList];
      setSourceCityData(cityListWithAll)
      setSourceCity({ CityID: loginData?.intBranchCityID, CityName: loginData?.strCityName });  // Update the state with the new city list
    }

    if (ownChildBranches?.length > 0) {
      const branchListWithAll = [{ BranchID: 0, BranchName: 'All' }, ...ownChildBranches];
      const filteredBranchList = branchListWithAll.filter(branch =>
        branch.CityID === (loginData?.intBranchCityID)
      );
      setSourceBranchData(filteredBranchList)
      //  setSourceBranchData(branchListWithAll);  // Update the state with the new branch list
      setSourceBranch({ BranchID: loginData?.intBranchID, BranchName: loginData?.strBranchName })
    }
  }, [cityList, ownChildBranches, loginData?.intBranchCityID, loginData?.intBranchID, loginData?.strCityName, loginData?.strBranchName]);
  useEffect(() => {
    if (!isEmpty(loginData)) {
      getCityList(loginData)
      const branchData = {
        intUserID: 0,
        intCompanyID: loginData?.intCompanyID,
        intIsActive: 1,
      }
      getOwnChildBranches(branchData, true, 24 * 60 * 60 * 1000)
    }
  }, [getCityList, getOwnChildBranches,  loginData?.intCompanyID, loginData?.intUserID])

 const filterData = {
        fromDate: moment(fromDate).format('DD-MMM-YY'),
        toDate: moment(toDate).format('DD-MMM-YY'),
        sourceBranch: sourceBranch?.BranchName,
        sourceCity: sourceCity?.CityName,
        dataType: 'entry',
    }
  const generateReport = (isPdf = false) => {
    if (sourceCity == '' || sourceCity == ' ') {
      setAlert({ show: true, msg: 'Please Select City', nextId: '' })
      return
    }
    if (sourceBranch == '' || sourceBranch == ' ') {
      setAlert({ show: true, msg: 'Please Select Branch', nextId: '' })
      return
    }
    const diffDays = Math.abs(toDate.diff(fromDate, 'days'))
    const isAllSelected = sourceCity?.CityID === 0 || sourceBranch?.BranchID === 0
    if (isAllSelected && diffDays > 15) {
      setAlert({ show: true, msg: 'For All selection, date range cannot exceed 15 days', nextId: '' })
      return
    } else if (!isAllSelected && diffDays > 31) {
      setAlert({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
      return
    }
    setLoader(true)
        const obj = {
          intCompanyID: loginData.intCompanyID,
          intBranchID: sourceBranch?.BranchID,
          FromDate: moment(fromDate).format('YYYY-MM-DD'),
          ToDate: moment(toDate).format('YYYY-MM-DD'),
          intUserID: loginData.intUserID,
          AllowViewAllReport: 1,
        }
        GetRequest(urls.getToPayStatementReport, obj)
            .then((res) => {
                if (res.status !== 'Success') {
                    throw new Error(res?.ErrMessage || 'Request Failed')
                }
                if (!Array.isArray(res?.Data?.table) || res?.Data?.table.length === 0) {
                    throw new Error('No Data Found')
                }
                const updatedData = res?.Data?.table.map((item, index) => ({
                    ...item,
                    dataType: 'entry',
                   
                }))
                const reportPayload = {
                    reportName,
                    criteriaHeaders: filterHeaderData,
                    criteriaData: [filterData],
                    tableData: updatedData,
                    mainHeader: columnHeaderUpdated,
                    isShowManageColumn: false,
                    manageColumnID: '',
                    hideHeader: false,
                }
                if (isPdf === true) {
                    downloadPDF({
                        reportName,
                        criteriaHeaders: filterHeaderData,
                        criteriaData: [filterData],
                        tableData: updatedData,
                        visibleColumns: columnHeaderUpdated,
                        loginData,
                        hideHeader: false,
                    })
                    return
                }
                const rid = Date.now().toString()
                if (!window.generatedReports) {
                    window.generatedReports = {}
                }
                window.generatedReports[rid] = reportPayload
                window.open(`/view-report?rid=${rid}`, '_blank')
            })
            .catch((err) => {
                setAlert({ show: true, msg: err.message, nextId: '' })
            })
            .finally(() => setLoader(false))
    }

  const selectedSourceCity = (obj) => {
    setSourceCity(obj)
    if (obj?.CityID === 0) {
      const branchListWithAll = [{ BranchID: 0, BranchName: 'All' }, ...ownChildBranches];
      setSourceBranchData(branchListWithAll);
      setSourceBranch(branchListWithAll[0])
    } else {
      const filteredBranches = ownChildBranches?.filter((val) => val.CityID === obj?.CityID);
      const branchListWithAll = [{ BranchID: 0, BranchName: 'All' }, ...filteredBranches];
      setSourceBranchData(branchListWithAll);
      setSourceBranch(branchListWithAll[0])

    }
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
        {!isFromUrl && <ReportHeading reportName={reportName} />}
        <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px' }}>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              label={`From Booking Date`}
              name={'from_date'}
              value={fromDate}
              id={'fromDate'}
              dateChange={(date) => {
                setFromDate(date)
                // focusElemnt('toDate')
              }}
              width={isFromUrl ? '100%' : '300px'}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              label={'To Booking Date'}
              name={'to_date'}
              value={toDate}
              id={'toDate'}
              dateChange={(date) => {
                setToDate(date)
                // focusElemnt('goButtonDate')
              }}
              width={isFromUrl ? '100%' : '300px'}
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={`City Name`}
              id={'cityID'}
              data={sourceCityData || []}
              defaultvalue={sourceCity?.CityName || ''}
              dataKey={`CityName`}
              idKey={`CityID`}
              onSelect={(obj) => { selectedSourceCity(obj) }}
              onReset={() => setSourceCity('')}
              width="100%"
              nextId={'selectedBranch'}
              prevId={'goButtonDate'}
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              id={'selectedBranch'}
              label={'Branch Name'}
              // data={roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 1 && roleRights?.Table1?.[0]?.AllowViewAllBranchReport == 0 ? ownChildBranches.filter((val) => val.SourceBranchID == loginData?.intBranchCityID) : ownChildBranches || []}
              data={sourceBranchData || []}
              searchPlaceholder={`Search By Branch`}
              defaultvalue={sourceBranch?.BranchName || ''}
              dataKey={`BranchName`}
              idKey={`BranchID`}
              onSelect={(val) => { setSourceBranch(val) }}
              onReset={() => setSourceBranch('')}
              nextId={'generateButton'}
              prevId={'paymentType'}
              width="100%"
            />
          </Item>
          {isFromUrl ?
            <Button variant="contained" sx={{ width: '100%', height: '40px' }} className="btn btn-primary" onClick={() => generateReport(true)} id="topayDownloadPdfBtn">
              DOWNLOAD PDF
            </Button> :
          <Item sx={sx.itemsx}>
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              // hideToggle={false}
              id1={'generateButton'}
              onClick1={generateReport}
            // onClick2={handleClick2}
            />
          </Item>}
        </Box>
      </Item>
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getCityList, getOwnChildBranches }
export default connect(mapStateToProps, mapDispatchToProps)(TopayStatenentReport)
